<div class="sigma_video-popup-wrap">
    <img src="assets/img/video.jpg" alt="img">
    <a href="https://www.youtube.com/watch?v=KH1pcNUTa6U" class="sigma_video-popup bg-white popup-youtube popup-lg">
        <i class="far fa-play"></i>
    </a>
</div>